import { render, staticRenderFns } from "./skuView.vue?vue&type=template&id=5bff420d&scoped=true"
import script from "./skuView.vue?vue&type=script&lang=js"
export * from "./skuView.vue?vue&type=script&lang=js"
import style0 from "./skuView.vue?vue&type=style&index=0&id=5bff420d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bff420d",
  null
  
)

export default component.exports